import React from 'react';
import { PageWrap, PageContent, PageSide, PageBody, PageHeader, PageFooter, PageNumber } from './styles';
import MagazineNode from './components/MagazineNode';
import useCommonProps from '../../../../../hooks/useCommonProps';
var MagazineBlock = function (_a) {
    var pages = _a.post.pages, index = _a.index;
    var isFirstPage = index === 0;
    var magazineData = useCommonProps().magazineData;
    return (React.createElement(PageWrap, null,
        React.createElement(PageContent, null,
            React.createElement(PageSide, null,
                React.createElement(PageHeader, null, "\u041A\u041E\u041B\u041E\u041D\u0422\u0418\u0422\u0423\u041B, \u041D\u0423\u0416\u041D\u041E \u0423\u0422\u041E\u0427\u041D\u0418\u0422\u042C \u041A\u0410\u041A\u041E\u0419 \u041D\u0410 \u041F\u0415\u0420\u0412\u041E\u0419 \u0421\u0422\u0420\u0410\u041D\u0418\u0426\u0415"),
                React.createElement(PageBody
                // spreadContent={isFirstPage}
                , null,
                    React.createElement(MagazineNode, { posts: pages[0] })),
                React.createElement(PageFooter, null,
                    React.createElement(PageNumber, null, (index + 1) * 2),
                    "\u042F\u043F\u043E\u043D\u0441\u043A\u043E\u0435 \u0438\u0441\u043A\u0443\u0441\u0441\u0442\u0432\u043E")),
            React.createElement(PageSide, { position: 'right' },
                React.createElement(PageHeader, { position: 'right' }, "\u041E\u0411\u0420\u0410\u0417\u041E\u0412\u0410\u041D\u0418\u0415"),
                React.createElement(PageBody, null,
                    React.createElement(MagazineNode, { posts: pages[1] })),
                React.createElement(PageFooter, { position: 'right' }, magazineData === null || magazineData === void 0 ? void 0 :
                    magazineData.bookTitle,
                    React.createElement(PageNumber, null, (index + 1) * 2 + 1))))));
};
export default MagazineBlock;
//# sourceMappingURL=MagazineBlock.js.mapimport React from 'react';
import { PageWrap, PageContent, PageSide, PageBody, PageHeader, PageFooter, PageNumber } from './styles';
import MagazineNode from './components/MagazineNode';
import useCommonProps from '../../../../../hooks/useCommonProps';
var MagazineBlock = function (_a) {
    var pages = _a.post.pages, index = _a.index;
    var isFirstPage = index === 0;
    var magazineData = useCommonProps().magazineData;
    return (React.createElement(PageWrap, null,
        React.createElement(PageContent, null,
            React.createElement(PageSide, null,
                React.createElement(PageHeader, null, "\u041A\u041E\u041B\u041E\u041D\u0422\u0418\u0422\u0423\u041B, \u041D\u0423\u0416\u041D\u041E \u0423\u0422\u041E\u0427\u041D\u0418\u0422\u042C \u041A\u0410\u041A\u041E\u0419 \u041D\u0410 \u041F\u0415\u0420\u0412\u041E\u0419 \u0421\u0422\u0420\u0410\u041D\u0418\u0426\u0415"),
                React.createElement(PageBody
                // spreadContent={isFirstPage}
                , null,
                    React.createElement(MagazineNode, { posts: pages[0] })),
                React.createElement(PageFooter, null,
                    React.createElement(PageNumber, null, (index + 1) * 2),
                    "\u042F\u043F\u043E\u043D\u0441\u043A\u043E\u0435 \u0438\u0441\u043A\u0443\u0441\u0441\u0442\u0432\u043E")),
            React.createElement(PageSide, { position: 'right' },
                React.createElement(PageHeader, { position: 'right' }, "\u041E\u0411\u0420\u0410\u0417\u041E\u0412\u0410\u041D\u0418\u0415"),
                React.createElement(PageBody, null,
                    React.createElement(MagazineNode, { posts: pages[1] })),
                React.createElement(PageFooter, { position: 'right' }, magazineData === null || magazineData === void 0 ? void 0 :
                    magazineData.bookTitle,
                    React.createElement(PageNumber, null, (index + 1) * 2 + 1))))));
};
export default MagazineBlock;
//# sourceMappingURL=MagazineBlock.js.map